import Vue from 'vue'
import axios from 'axios'
import * as _ from 'lodash'

export default {
    state: {
        drivershareTimesheets: [],
    },

    mutations: {
        setDrivershareTimesheets(state, payload) {
            state.drivershareTimesheets = payload
        },

        addDrivershareTimesheet(state, payload) {
            state.drivershareTimesheets.unshift(payload)
        },

        editDrivershareTimesheet(state, payload) {
            const index = state.drivershareTimesheets.findIndex(item => item.id === payload.id)
            if (index !== -1) {
                Vue.set(state.drivershareTimesheets, index, {
                    ...state.drivershareTimesheets[index],
                    ...payload
                })
            }
        },

        removeDrivershareTimesheet(state, id) {
            state.drivershareTimesheets =
                state.drivershareTimesheets.filter(item => item.id !== id)
        },

        addDrivershareTimesheets(state, payload) {
            state.drivershareTimesheets = [
                ...state.drivershareTimesheets,
                ...payload
            ]
        },
    },

    actions: {

        // Fetch
        async fetchDrivershareTimesheets({ commit, dispatch }, params) {
            commit('clearError')
            commit('setLoading', true)

            const user = JSON.parse(localStorage.getItem('user'))

            try {
                const { data } = await axios.get(
                    `${this._vm.appConfig.app_url}/api/drivershare-timesheet`,
                    {
                        params,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Authorization': `Bearer ${user.access_token}`
                        }
                    }
                )
                console.log("FULL RESPONSE:", data)


                commit('setDrivershareTimesheets', data)
                return data
            } catch (error) {
                dispatch('_handleDrivershareTimesheetError', { error, dispatch })
                throw error
            } finally {
                commit('setLoading', false)
            }
        },

        // Create
        async createDrivershareTimesheet({ commit, dispatch }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const user = JSON.parse(localStorage.getItem('user'))

            try {
                const { data } = await axios.post(
                    `${this._vm.appConfig.app_url}/api/drivershare-timesheet`,
                    payload,
                    {
                        headers: {
                            'Authorization': `Bearer ${user.access_token}`
                        }
                    }
                )

                commit('addDrivershareTimesheet', data)
                return data
            } catch (error) {
                dispatch('_handleDrivershareTimesheetError', { error, dispatch })
                throw error
            } finally {
                commit('setLoading', false)
            }
        },

        // Update
        async updateDrivershareTimesheet({ commit, dispatch }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const user = JSON.parse(localStorage.getItem('user'))

            try {
                const { data } = await axios.patch(
                    `${this._vm.appConfig.app_url}/api/drivershare-timesheet/${payload.id}`,
                    payload,
                    {
                        headers: {
                            'Authorization': `Bearer ${user.access_token}`
                        }
                    }
                )

                commit('editDrivershareTimesheet', data.timesheet)
                return data
            } catch (error) {
                dispatch('_handleDrivershareTimesheetError', { error, dispatch })
                throw error
            } finally {
                commit('setLoading', false)
            }
        },

        // Delete
        async deleteDrivershareTimesheet({ commit, dispatch }, id) {
            commit('clearError')
            commit('setLoading', true)

            const user = JSON.parse(localStorage.getItem('user'))

            try {
                await axios.delete(
                    `${this._vm.appConfig.app_url}/api/drivershare-timesheet/${id}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${user.access_token}`
                        }
                    }
                )

                commit('removeDrivershareTimesheet', id)
            } catch (error) {
                dispatch('_handleDrivershareTimesheetError', { error, dispatch })
                throw error
            } finally {
                commit('setLoading', false)
            }
        },

        // ================= ERROR HANDLER =================
        _handleDrivershareTimesheetError({ dispatch }, { error }) {
            if (error.response) {
                const { status, data } = error.response

                if (status === 401) {
                    dispatch('logOutUser')
                    window.location.reload()
                    return
                }

                if (status === 400 || status === 422) {
                    const msg = data.message || _.values(data.errors || data)[0]
                    dispatch('setError', Array.isArray(msg) ? msg[0] : msg)
                    return
                }
            }

            dispatch('setError', error.message || error)
        },
    },

    getters: {
        drivershareTimesheets(state) {
            return state.drivershareTimesheets
        }
    }
}